import React, {
  useReducer, useRef, useEffect,
} from 'react';
import { createPortal } from 'react-dom';
import ToastNotificationList from './ToastNotificationList';

const initialState = [];

const Actions = {
  ADD_TOAST_NOTIFICATION: 'ADD_TOAST_NOTIFICATION',
  REMOVE_TOAST_NOTIFICATION: 'REMOVE_TOAST_NOTIFICATION',
};

const NotificationType = {
  ERROR: 'error',
  SUCCESS: 'success',
};

function toastNotificationReducer(state, action) {
  switch (action.type) {
    case Actions.ADD_TOAST_NOTIFICATION: {
      const id = window.btoa(unescape(encodeURIComponent(action.payload.message)));
      if (state.some((n) => n.id === id)) return state;
      return [...state, { ...action.payload, id }];
    }
    case Actions.REMOVE_TOAST_NOTIFICATION: {
      return state.filter((notification) => notification.id !== action.payload);
    }
    default:
      return state;
  }
}

const toastManager = (function ToastManager() {
  let callbackFn;

  const manager = {
    subscribe(callback) {
      callbackFn = callback;
    },
    add(type, content) {
      const timeoutId = window.setTimeout(() => {
        callbackFn(Actions.ADD_TOAST_NOTIFICATION, { message: content, type });
      });
      return timeoutId;
    },
    remove(id) {
      callbackFn(Actions.REMOVE_TOAST_NOTIFICATION, id);
      return true;
    },
  };
  return manager;
}());

export const toast = {
  show: (type, content) => toastManager.add(type, content),
  success: (content) => toastManager.add(NotificationType.SUCCESS, content),
  error: (content) => toastManager.add(NotificationType.ERROR, content),
  remove: (id) => toastManager.remove(id),
};

const ToastNotifications = (props) => {
  const { onClose = null, autoCloseDuration = 5 } = props;
  const toastRootElementId = 'toast-notification-container';
  const [state, dispatch] = useReducer(toastNotificationReducer, initialState);
  const toastRef = useRef(null);

  const callback = (type, payload) => {
    dispatch({ type, payload });
  };

  useEffect(() => {
    toastManager.subscribe(callback);
  }, []);

  useEffect(() => {
    const node = document.createElement('div');
    node.setAttribute('id', toastRootElementId);
    document.body.appendChild(node);
    toastRef.current = node;
    return () => document.body.removeChild(node);
  }, []);

  if (!toastRef.current) return null;

  const handleClose = (id) => {
    toast.remove(id);
    if (onClose) onClose(id);
  };

  return createPortal(
    <ToastNotificationList
      notifications={state}
      autoCloseDuration={autoCloseDuration}
      close={handleClose}
    />,
    toastRef.current,
  );
};

export default ToastNotifications;
